import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DeliverRequest, DispatchLoads, FeedStockDispatchDetails, FeedstockListRequest, FeedStockLoadInfoResponse, FeedStockLoadScheduleDispatchDataResponse, FeedstockLoadScheduleResponse, FSLoadStatus, GetDeepackOutboundRequest, GetDeepackOutboundResponse, SaveFeedstockLoadScheduleRequest, UpdateFeedStockSampleStatusRequest, UpdateFSInternalNotesRequest, UserGridColumnPreferenceRequest, UserGridColumnPreferenceResponse } from '../interfaces/feedstocklistmodel';
import { environment } from '../environments/environment';
import { CustomerData, GeneratorsList, GetMarketGeneratorsResponse, SaveCustomerRequest, SaveGeneratorStreamRequest, SaveStreamPickupLocationRequest, SaveStreamRecurringLoadsRequest, SaveStreamRequest, SaveStreamSampleFreqRequest } from '../interfaces/generatorsmodel';
import { GetStreamsResponse, StreamsList } from '../interfaces/streamsmodel';
import { FeedStockLoadAdditionalRevenue, FeedStockLoadDispatchRequestCommand, FeedStockLoadDocumentResponse, FeedStockSchedulePriceMatrixRequest, FeedStockSchedulePriceMatrixResponse, FieldConfiguration, GetToterPriceMatrixByIdResponse, IdName, PriceMatrixList, PriceMatrixSalesRep, TotePriceMatrix, ToteRentalType, ToterPriceMatrix } from '../interfaces/pricematrixmodel';
import { LabChemistryList, SaveStreamBiologyChemistryRequest } from '../interfaces/labchemistrymodel';
import { GetLabMetalsByIdResponse, LabMetalsList, SaveStreamBiologyMetalsRequest } from '../interfaces/labmetalsmodel';
import { FeedstockStatus, GetActualVolumeTonsForAmeliaSitesResponse } from '../interfaces/feedstockstatus';
import { feedStockLoadAdditionalRevenue, FeedstockLoadScheduleWithAdditionalStreamsByIdResponse } from '../interfaces/feedStockLoadAdditionalRevenue';
import { observableToBeFn } from 'rxjs/internal/testing/TestScheduler';
import { blob } from 'stream/consumers';
import { GetStreamRecurringLoadsResponse, StreamSamplingFreq } from '../interfaces/streamrecurringLoad';
import { SiteTanksResponse } from '../interfaces/regions';
import { SchedulingSitesResponse } from '../interfaces/siteType';
import { LoadProjectionsRecord } from '../interfaces/load-projections-record';
import internal from 'stream';
import { request } from 'http';

@Injectable({
  providedIn: 'root'
})
export class FeedstockService {
  baseUrl = environment.baseUrl + 'feedstocks/';
  constructor(private http: HttpClient) { }

  getFeedstockList(request: FeedstockListRequest): Observable<FeedstockLoadScheduleResponse[]> {

    const params = new URLSearchParams();
    if (request.marketIds) {
      params.append('marketIds', request.marketIds);
    }
    if (request.genIds) {
      params.append('genIds', request.genIds);
    }
    if (request.streamIds) {
      params.append('streamIds', request.streamIds);
    }
    if (request.siteIds) {
      params.append('siteIds', request.siteIds);
    }
    params.append('fromDate', request.fromDate ?? '');
    params.append('toDate', request.toDate ?? '');
    params.append('ScheduleTypeId', request.scheduleTypeId.toString());
    params.append('StatusId', request.statusId.toString());

    var url = `${this.baseUrl}?${params.toString()}`;
    return this.http.get<FeedstockLoadScheduleResponse[]>(url);
  }

  getDepackOutboundData(request: GetDeepackOutboundRequest): Observable<GetDeepackOutboundResponse[]>{
    return this.http.post<GetDeepackOutboundResponse[]>(
      `${this.baseUrl}GetDeepackOutbound`,
      request
    );
  }

  getFeedStockStatus(): Observable<FeedstockStatus[]> {
    var url = `${this.baseUrl}GetFeedstockStatusByRole`;
    return this.http.get<FeedstockStatus[]>(url);
  }

  getGeneratorList(MarketIds: string): Observable<GeneratorsList[]> {
    var url = `${environment.baseUrl}generators?marketIds=${MarketIds}`;
    return this.http.get<GeneratorsList[]>(url);
  }

  getToteGenerators(MarketIds: string): Observable<GetMarketGeneratorsResponse[]> {
    var url = `${environment.baseUrl}generators/GetGeneratorsByMarketLookup?marketId=${MarketIds}&isTote=true`;
    return this.http.get<GetMarketGeneratorsResponse[]>(url);
  }

  getmarketGenerators(marketId: number, isTote: boolean): Observable<GetMarketGeneratorsResponse[]> {
    var url = `${environment.baseUrl}generators/GetGeneratorsByMarketLookup?marketId=${marketId}&isTote=${isTote}`;
    return this.http.get<GetMarketGeneratorsResponse[]>(url);
  }

  getStreamList(MarketIds: string, GenIds: string): Observable<StreamsList[]> {
    var url = `${environment.baseUrl}streams?marketIds=${MarketIds}&genIds=${GenIds}`;
    return this.http.get<StreamsList[]>(url);
  }
  getExistingStreamList(customerId: number): Observable<GetStreamsResponse[]> {
    var url = `${environment.baseUrl}streams/GetStreamsByGeneratorsLookup?customerId=${customerId}`;
    return this.http.get<GetStreamsResponse[]>(url);
  }

  getPMStreamList(GenIds: string): Observable<IdName[]> {
    var url = `${environment.baseUrl}pricematrix/GetStreams?genId=${GenIds}`;
    return this.http.get<IdName[]>(url);
  }

  getStreamDropdownList(cid: string): Observable<StreamsList[]> {
    var url = `${environment.baseUrl}streams/GetMaterialStreamsLoads?customerId=${cid}`;
    return this.http.get<StreamsList[]>(url);
  }

  getToteStreamList(GenIds: string): Observable<IdName[]> {
    var url = `${environment.baseUrl}streams/GetToteMaterialStreams?customerId=${GenIds}`;
    return this.http.get<IdName[]>(url);
  }

  getStreamRecurringLoads(streamId: number, GenId: number): Observable<GetStreamRecurringLoadsResponse[]> {
    var url = `${environment.baseUrl}streams/GetStreamRecurringLoads?ID=${streamId}&CID=${GenId}`;
    return this.http.get<GetStreamRecurringLoadsResponse[]>(url);
  }


  getPriceMatrixById(id: number): Observable<PriceMatrixList> {
    var url = `${environment.baseUrl}pricematrix/GetPriceMatrixById?Id=${id}`;
    return this.http.get<PriceMatrixList>(url);
  }

  getTotePriceMatrixById(id: number): Observable<TotePriceMatrix> {
    var url = `${environment.baseUrl}pricematrix/GetToterPriceMatrixById?Id=${id}`;
    return this.http.get<TotePriceMatrix>(url);
  }
  getStreamSamplingFrequencies(streamId: number, GenId: number): Observable<StreamSamplingFreq[]> {
    var url = `${environment.baseUrl}streams/GetStreamSamplingFreqResponse?StreamId=${streamId}&CustomerId=${GenId}`;
    return this.http.get<StreamSamplingFreq[]>(url);
  }
  getWeekDays(): Observable<IdName[]> {
    var url = `${environment.baseUrl}streams/GetWeekDays`;
    return this.http.get<IdName[]>(url);
  }
  getWeekDaysSeq(): Observable<IdName[]> {
    var url = `${environment.baseUrl}streams/GetWeekdaySequence`;
    return this.http.get<IdName[]>(url);
  }

  getRecurrType(): Observable<IdName[]> {
    var url = `${environment.baseUrl}streams/GetStreamLoadRecurType`;
    return this.http.get<IdName[]>(url);
  }

  getSchedulingSites(typeid: number, siteType: number): Observable<SchedulingSitesResponse[]> {
    var url = `${environment.baseUrl}masters/GetSchedulingSites?ScheduleType=${typeid}&&DropSiteType=${siteType}`;
    return this.http.get<SchedulingSitesResponse[]>(url);
  }

  getDisposalSitesForHaulerPricing(): Observable<SchedulingSitesResponse[]> {
    var url = `${environment.baseUrl}masters/GetDisposalSitesForHaulerPricing`;
    return this.http.get<SchedulingSitesResponse[]>(url);
  }

  getDispatchDetails(fsLoadScheduleId: number): Observable<FeedStockLoadScheduleDispatchDataResponse[]> {
    var url = `${this.baseUrl}GetFeedStockLoadDispatchData?feedStockLoadScheduleId=${fsLoadScheduleId}`;
    return this.http.get<FeedStockLoadScheduleDispatchDataResponse[]>(url);
  }

  getPriceMatrixList(GenId: number, StreamId: number): Observable<PriceMatrixList[]> {
    var url = `${environment.baseUrl}pricematrix?genId=${GenId}&streamId=${StreamId}`;
    return this.http.get<PriceMatrixList[]>(url);
  }

  getPMSalesRep(Id: number): Observable<PriceMatrixSalesRep[]> {
    var url = `${environment.baseUrl}pricematrix/GetPriceMatrixSalesReps?Id=${Id}`;
    return this.http.get<PriceMatrixSalesRep[]>(url);
  }

  getTotePriceMatrixList(GenId: number, StreamId: number): Observable<TotePriceMatrix[]> {
    var url = `${environment.baseUrl}pricematrix/GetToterPriceMatrix?customerId=${GenId}&streamId=${StreamId}`;
    return this.http.get<TotePriceMatrix[]>(url);
  }

  getToteRentalTypes(pmId: number): Observable<GetToterPriceMatrixByIdResponse> {
    var url = `${environment.baseUrl}pricematrix/GetToterPriceMatrixById?Id=${pmId}`;
    return this.http.get<GetToterPriceMatrixByIdResponse>(url);
  }

  getTPMFieldConfig(GenId: number): Observable<FieldConfiguration[]> {
    var url = `${environment.baseUrl}pricematrix/GetToterPriceMatrixFieldConfigurations?customerId=${GenId}`;
    return this.http.get<FieldConfiguration[]>(url);
  }

  getChemistryList(StreamId: number): Observable<LabChemistryList[]> {
    var url = `${environment.baseUrl}labchemistry?streamId=${StreamId}`;
    return this.http.get<LabChemistryList[]>(url);
  }

  getMetalsList(StreamId: number): Observable<LabMetalsList[]> {
    var url = `${environment.baseUrl}labmetals?streamId=${StreamId}`;
    return this.http.get<LabMetalsList[]>(url);
  }

  getMetalsDataById(id: number): Observable<GetLabMetalsByIdResponse> {
    var url = `${environment.baseUrl}labmetals/GetLabMetalsById?id=${id}`;
    return this.http.get<GetLabMetalsByIdResponse>(url);
  }

  getFeedStockStatuses(role: string): Observable<FeedstockStatus[]> {
    var url = `${this.baseUrl}GetFeedstockStatusByRole/${role}`;
    return this.http.get<FeedstockStatus[]>(url);
  }

  getActualVolumeTonsForAmeliaSites(): Observable<GetActualVolumeTonsForAmeliaSitesResponse> {
    var url = `${this.baseUrl}GetActualVolumeTonsForAmeliaSites`;
    return this.http.get<GetActualVolumeTonsForAmeliaSitesResponse>(url);
  }

  getFeedStockAdditionalRevenue(fsLoadScheduleId: number): Observable<feedStockLoadAdditionalRevenue[]> {
    const url = `${this.baseUrl}GetFeedStockLoadAdditionalRevenue?fsLoadScheduleId=${fsLoadScheduleId}`;
    return this.http.get<feedStockLoadAdditionalRevenue[]>(url);
  }

  getFeedStockLoadByid(fsLoadScheduleId: number | null, scheduletype: number): Observable<FeedstockLoadScheduleWithAdditionalStreamsByIdResponse> {
    const url = `${this.baseUrl}GetFeedstockloadscheduleById?loadScheduleId=${fsLoadScheduleId}&scheduleTypeId=${scheduletype}`;
    return this.http.get<FeedstockLoadScheduleWithAdditionalStreamsByIdResponse>(url);
  }

  getAdditionalRevenue(fsLoadId: number): Observable<FeedStockLoadAdditionalRevenue[]> {
    const url = `${this.baseUrl}GetFeedStockLoadAdditionalRevenue?fsLoadScheduleId=${fsLoadId}`;
    return this.http.get<FeedStockLoadAdditionalRevenue[]>(url);
  }

  getFeedStockLoadInfoById(fsLoadId: number): Observable<FeedStockLoadInfoResponse> {
    const url = `${this.baseUrl}getFeedStockLoadInfoById?loadScheduleId=${fsLoadId}`;
    return this.http.get<FeedStockLoadInfoResponse>(url);
  }

  getLoadslipByStream(id: number): Observable<boolean> {
    const url = `${environment.baseUrl}streams/GetLoadSlipByStreamId?StreamId=${id}`;
    return this.http.get<boolean>(url);
  }

  getLoadslipByPMId(id: number): Observable<boolean> {
    const url = `${environment.baseUrl}pricematrix/HasContractDocument?PriceMatrixId=${id}`;
    return this.http.get<boolean>(url);
  }

  saveLoadData(payload: SaveFeedstockLoadScheduleRequest): Observable<boolean> {
    const saveApiUrl = environment.baseUrl + 'feedstocks';
    return this.http.post<boolean>(saveApiUrl, payload);
  }
  saveDepackLoadData(payload: FormData): Observable<boolean> {
    const saveApiUrl = environment.baseUrl + 'feedstocks/SaveDepackLoadSchedule';
    return this.http.post<boolean>(saveApiUrl, payload);
  }
  updateNotes(payload: UpdateFSInternalNotesRequest): Observable<boolean> {
    const saveApiUrl = environment.baseUrl + 'feedstocks/UpdateFSInternalNotes';
    return this.http.put<boolean>(saveApiUrl, payload);
  }

  saveFeedStockLoadAdditionalRevenue(payload: FeedStockLoadAdditionalRevenue): Observable<boolean> {
    const saveApiUrl = environment.baseUrl + 'feedstocks/SaveFeedStockLoadAdditionalRevenue';
    return this.http.post<boolean>(saveApiUrl, payload);
  }

  deleteFSLoadAdditionalStreamsById(id: number): Observable<boolean> {
    const params = new HttpParams().set('fsLoadAdditionalStreamId', id.toString());
    const deleteApiUrl = environment.baseUrl + 'feedstocks/DeleteFeedStockLoadAdditionalStreams';
    return this.http.delete<boolean>(`${deleteApiUrl}`, { params: params });
  }

  saveDispatchDetails(payload: FeedStockLoadDispatchRequestCommand): Observable<boolean> {
    const saveApiUrl = environment.baseUrl + 'feedstocks/SaveFeedStockLoadDispatch';
    return this.http.post<boolean>(saveApiUrl, payload);
  }

  saveGenerator(payload: SaveCustomerRequest): Observable<number> {
    const saveApiUrl = environment.baseUrl + 'generators/SaveCustomer';
    return this.http.post<number>(saveApiUrl, payload);
  }

  saveStream(payload: SaveStreamRequest): Observable<boolean> {
    const saveApiUrl = environment.baseUrl + 'streams/SaveStream';
    return this.http.post<boolean>(saveApiUrl, payload);
  }

  saveExistingStream(payload: SaveGeneratorStreamRequest): Observable<boolean> {
    const saveApiUrl = environment.baseUrl + 'streams/SaveGeneratorStream';
    return this.http.post<boolean>(saveApiUrl, payload);
  }

  saveRecurringLoad(payload: SaveStreamRecurringLoadsRequest): Observable<boolean> {
    const saveApiUrl = environment.baseUrl + 'streams/SaveStreamRecurringLoads';
    return this.http.post<boolean>(saveApiUrl, payload);
  }

  savePickUpLoc(payload: SaveStreamPickupLocationRequest): Observable<boolean> {
    const saveApiUrl = environment.baseUrl + 'streams/SaveStreamPickupLocation';
    return this.http.post<boolean>(saveApiUrl, payload);
  }

  saveSampleFreq(payload: SaveStreamSampleFreqRequest): Observable<boolean> {
    const saveApiUrl = environment.baseUrl + 'streams/SaveStreamSampleFreq';
    return this.http.post<boolean>(saveApiUrl, payload);
  }

  savePM(payload: PriceMatrixList): Observable<boolean> {
    const saveApiUrl = environment.baseUrl + 'pricematrix';
    return this.http.post<boolean>(saveApiUrl, payload);
  }

  deletePMSalesrep(id: number): Observable<boolean> {
    const apiUrl = `${environment.baseUrl}pricematrix/DeletePriceMatrixSalesRep?id=${id}`;
    return this.http.delete<boolean>(apiUrl);
  }

  saveTPM(payload: TotePriceMatrix): Observable<boolean> {
    const saveApiUrl = environment.baseUrl + 'pricematrix/SaveToterPriceMatrix';
    return this.http.post<boolean>(saveApiUrl, payload);
  }

  saveChemistry(payload: SaveStreamBiologyChemistryRequest): Observable<boolean> {
    const saveApiUrl = environment.baseUrl + 'labchemistry/SaveLabDataChemistry';
    return this.http.post<boolean>(saveApiUrl, payload);
  }

  saveMetals(payload: SaveStreamBiologyMetalsRequest): Observable<boolean> {
    const saveApiUrl = environment.baseUrl + 'labmetals/SaveStreamBiologyMetals';
    return this.http.post<boolean>(saveApiUrl, payload);
  }

  UpdateFeedstockLoadStatus(payload: FSLoadStatus[]): Observable<boolean> {
    const saveApiUrl = environment.baseUrl + 'feedstocks/UpdateFeedstockLoadStatus';
    return this.http.post<boolean>(saveApiUrl, payload);
  }

  UpdateFeedstockSampleStatus(payload: UpdateFeedStockSampleStatusRequest): Observable<boolean> {
    const saveApiUrl = environment.baseUrl + 'feedstocks/UpdateFeedStockSampleStatus';
    return this.http.put<boolean>(saveApiUrl, payload);
  }

  uploadLoadDocument(payload: FormData): Observable<boolean> {
    const saveApiUrl = environment.baseUrl + 'feedstocks/SaveFeedStockDocs';
    return this.http.post<boolean>(saveApiUrl, payload);
  }

  saveFeedStockAdditionalRevenue(payload: feedStockLoadAdditionalRevenue): Observable<boolean> {
    const saveApiUrl = `${this.baseUrl}SaveFeedStockLoadAdditionalRevenue`;
    return this.http.post<boolean>(saveApiUrl, payload);
  }

  dispatchFeedStockLoads(payload: FeedStockDispatchDetails[], screenId: string): Observable<boolean> {
    const deliverRequest: DeliverRequest = {
      dispatchIds: payload.map(p => p.fsLoadScheduleId.toString()),
      schedulerType: screenId
    };
    const saveApiUrl = environment.baseUrl + 'feedstocks/SendDeliverRequests';
    return this.http.post<boolean>(saveApiUrl, deliverRequest);
  }

  getPriceMatrix(request: FeedStockSchedulePriceMatrixRequest): Observable<FeedStockSchedulePriceMatrixResponse> {
    var url = `${this.baseUrl}GetFeedStockSchedulePriceMatrix`;
    return this.http.post<FeedStockSchedulePriceMatrixResponse>(url, request);
  }

  getHaulingExpense(request: FeedStockSchedulePriceMatrixRequest): Observable<number> {
    const url = `${this.baseUrl}GetHaulingExpense`;
    const params = new HttpParams()
      .set('HaulerId', request.haulerId.toString())
      .set('StreamId', request.streamId.toString())
      .set('DisposalSite', request.siteId.toString())
      .set('GeneratorId', request.customerId.toString())
    return this.http.get<number>(url, { params });
  }
  
  getPriceMatrixForStream(
    request: FeedStockSchedulePriceMatrixRequest
  ): Observable<FeedStockSchedulePriceMatrixResponse> {

    const url = `${this.baseUrl}GetPriceMatrixForStream`;

    const params = new HttpParams()
      .set('CustomerId', request.customerId.toString())
      .set('Streamid', request.streamId.toString())
      .set('Siteid', request.siteId.toString())
      .set('Haulerid', request.haulerId.toString())
      .set('DateReceived', request.dateReceived);

    return this.http.get<FeedStockSchedulePriceMatrixResponse>(url, { params });
  }
  getFeedStockLoadAdditionalRevenue(id: number): Observable<FeedStockLoadAdditionalRevenue> {
    var url = `${this.baseUrl}GetFeedStockLoadAdditionalRevenue?fsLoadScheduleId=${id}`;
    return this.http.get<FeedStockLoadAdditionalRevenue>(url);
  }

  getDocuments(id: number, screenTypeId: number): Observable<FeedStockLoadDocumentResponse[]> {
    var url = `${this.baseUrl}GetDocumentDetails?FS_LoadScheduleId=${id}&ScreenTypeId=${screenTypeId}`;
    return this.http.get<FeedStockLoadDocumentResponse[]>(url);
  }

  deleteFeedstockloadscheduleById(loadScheduleId: number): Observable<boolean> {
    const params = new HttpParams().set('loadScheduleId', loadScheduleId.toString());
    const deleteApiUrl = environment.baseUrl + 'feedstocks';
    return this.http.delete<boolean>(`${deleteApiUrl}`, { params: params });
  }

  deleteRecurrLoad(loadid: number): Observable<boolean> {
    const params = new HttpParams().set('Id', loadid.toString());
    const deleteApiUrl = environment.baseUrl + 'streams/DeleteStreamRecurringLoads';
    return this.http.delete<boolean>(`${deleteApiUrl}`, { params: params });
  }

  deleteSampleFreq(loadid: number): Observable<boolean> {
    const params = new HttpParams().set('Id', loadid.toString());
    const deleteApiUrl = environment.baseUrl + 'streams/DeleteStreamSampleFreq';
    return this.http.delete<boolean>(`${deleteApiUrl}`, { params: params });
  }

  deletePickupLoc(loadid: number): Observable<boolean> {
    const params = new HttpParams().set('Id', loadid.toString());
    const deleteApiUrl = environment.baseUrl + 'streams/DeleteStreamPickUpLocation';
    return this.http.delete<boolean>(`${deleteApiUrl}`, { params: params });
  }

  deleteCustomer(id: number): Observable<number> {
    const params = new HttpParams().set('customerId', id);
    const deleteApiUrl = environment.baseUrl + 'generators/DeleteCustomer';
    return this.http.delete<number>(`${deleteApiUrl}`, { params: params });
  }

  deleteStream(id: number, genId: number): Observable<number> {
    var params = new HttpParams().set('streamId', id);
    params = params.append('generatorId', genId);
    const deleteApiUrl = environment.baseUrl + 'streams/DeleteMaterialStream';
    return this.http.delete<number>(`${deleteApiUrl}`, { params: params });
  }

  deletePriceMatrix(id: number): Observable<number> {
    var params = new HttpParams().set('id', id);
    const deleteApiUrl = environment.baseUrl + 'pricematrix/DeletePriceMatrix';
    return this.http.delete<number>(`${deleteApiUrl}`, { params: params });
  }

  deleteTotePriceMatrix(id: number): Observable<number> {
    var params = new HttpParams().set('id', id);
    const deleteApiUrl = environment.baseUrl + 'pricematrix/DeleteTotePriceMatrix';
    return this.http.delete<number>(`${deleteApiUrl}`, { params: params });
  }

  deleteMetal(id: number): Observable<number> {
    var params = new HttpParams().set('id', id);
    const deleteApiUrl = environment.baseUrl + 'labmetals';
    return this.http.delete<number>(`${deleteApiUrl}`, { params: params });
  }

  deleteChemistry(id: number): Observable<number> {
    var params = new HttpParams().set('id', id);
    const deleteApiUrl = environment.baseUrl + 'labchemistry';
    return this.http.delete<number>(`${deleteApiUrl}`, { params: params });
  }

  deleteDocument(fileName: string, blobid: string, typeid: number): Observable<boolean> {
    var params = new HttpParams().set('fileName', fileName);
    params = params.append('blobID', blobid);
    params = params.append('Type', typeid);
    const deleteApiUrl = environment.baseUrl + 'feedstocks/DeleteDocument';
    return this.http.delete<boolean>(`${deleteApiUrl}`, { params: params });
  }

  deleteFeedStockLoadAdditionalRevenue(id: number): Observable<boolean> {
    const params = new HttpParams().set('fsLoadAdditionalRevenueId', id.toString());
    const deleteApiUrl = environment.baseUrl + 'feedstocks/DeleteFeedStockLoadAdditionalRevenue';
    return this.http.delete<boolean>(`${deleteApiUrl}`, { params: params });
  }

  deleteRPCById(id: number): Observable<boolean> {
    const params = new HttpParams().set('Id', id.toString());
    const deleteApiUrl = environment.baseUrl + 'feedstocks/DeleteRPCtypeById';
    return this.http.delete<boolean>(`${deleteApiUrl}`, { params: params });
  }

  downloadDocument(document: FeedStockLoadDocumentResponse): Observable<Blob> {
    const params = new HttpParams()
      .set('fileName', document.name ?? '')
      .set('blobID', document.blobID ?? '')
      .set('Type', document.docTypeId ?? '');
    const dwnApiUrl = environment.baseUrl + 'feedstocks/DownloadDocument';
    return this.http.get<Blob>(`${dwnApiUrl}`, {
      params,
      responseType: 'blob' as 'json'
    });
  }

  getLoadProjections(siteId: number | null): Observable<LoadProjectionsRecord[]> {
    var params = new HttpParams();
    if (siteId !== null)
      params = new HttpParams().set('siteId', siteId);
    var url = `${this.baseUrl}GetAllFeedstockLoadProjection`;
    return this.http.get<LoadProjectionsRecord[]>(url, { params: params });
  }

  updateLoadProjectionStatus(payload: any): Observable<boolean> {
    const saveApiUrl = `${this.baseUrl}/UpdateFeedstockLoadProjectionStatus`;
    return this.http.post<boolean>(saveApiUrl, payload);
  }
  getUserGridColumnPreferences(gridId: number) {
    return this.http.get<UserGridColumnPreferenceResponse>(
      `${this.baseUrl}GetUserGridColumnPreferences?gridId=1`
    );
  }

  saveUserGridColumnPreferences(request: UserGridColumnPreferenceRequest) {
    return this.http.post<boolean>(
      `${this.baseUrl}SaveUserGridColumnPreferences`,
      request
    );
  }
}
